import { call, put, select } from 'redux-saga/effects';
import { setCards } from './actions';
import { selectCardsById, selectCardsLoaded } from './selectors';
import { all } from '../services/card';

/**
 * Game events carry card references (id, place in the pile, attachments); what each card is comes from the
 * catalog, which is loaded once.
 */
export function* ensureCards() {
  if (!(yield select(selectCardsLoaded))) {
    const cards = yield call(all);
    yield put(setCards(cards));
  }

  return yield select(selectCardsById);
}
